const message = {
  routes: [
    {
      path: '/messageList',
      name: 'messageList',
      meta: {
        isShowHeader: true,
        keepAlive: false,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '消息中心',
            path: '/messageList'
          }
        ]
      },
      component: () => import('@/project/views/message/list')
    },
    {
      path: '/messageShow/:id',
      name: 'messageShow',
      meta: {
        isShowHeader: true,
        keepAlive: false,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '消息中心',
            path: '/messageList'
          },
          {
            name: '消息详情',
            path: '/message/show'
          }
        ]
      },
      component: () => import('@/project/views/message/show')
    }
  ]
}
export default message



// WEBPACK FOOTER //
// ./src/project/router/message.js